import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  Typography
} from "@mui/material";

export default function CustomDateRangePopup({ onApply, open, setOpen, dateRangeCancel, startDate, setStartDate, endDate, setEndDate }) {
  const formatDate = (date) => date.toISOString().split("T")[0];

  const today = formatDate(new Date());
  const [error, setError] = useState("");

  const validateDates = (start, end) => {
    const startObj = new Date(start);
    const endObj = new Date(end);
    const now = new Date();

    if (startObj > endObj) {
      setError("Start date cannot be later than end date.");
      return false;
    }
    if (endObj > now) {
      setError("End date cannot be in the future.");
      return false;
    }

    setError("");
    return true;
  };

  const handleApply = () => {
    if (validateDates(startDate, endDate)) {
      setOpen(false);
      if (onApply) onApply({ start: startDate, end: endDate });
    }
  };

  const handleStartChange = (e) => {
    const newStart = e.target.value;
    setStartDate(newStart);
    validateDates(newStart, endDate);
  };

  const handleEndChange = (e) => {
    const newEnd = e.target.value;
    setEndDate(newEnd);
    validateDates(startDate, newEnd);
  };

  return (
    <>
      <Button variant="outlined" sx={{
        textTransform: "none",
        padding: "2px 8px ",
        borderColor: "#ccc",  // for outlined buttons
        "&:hover": { color: "gray" }, // optional hover effect
      }} onClick={() => setOpen(true)}>
        {/* Select Date Range */}
        <Typography
          variant="caption"
          sx={{
            color: "#2A2F3D",
            fontSize: "16px",
            padding: 0
          }}
        >
          Select Date Range
        </Typography>
      </Button>


      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Select Custom Date Range</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1, minWidth: 250 }}>
            <TextField
              label="Start Date"
              type="date"
              value={startDate}
              onChange={handleStartChange}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
              InputLabelProps={{ shrink: true }}
              sx={{ 
                "& .MuiInputBase-input": { cursor: "pointer" },
                "& .MuiInputBase-root": { cursor: "pointer" },
                "& input[type='date']::-webkit-calendar-picker-indicator": { cursor: "pointer" }
              }}
              inputProps={{
                max: endDate || today,
              }}
            />

            <TextField
              label="End Date"
              type="date"
              value={endDate}
              onChange={handleEndChange}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
              InputLabelProps={{ shrink: true }}
              sx={{ 
                "& .MuiInputBase-input": { cursor: "pointer" },
                "& .MuiInputBase-root": { cursor: "pointer" },
                "& input[type='date']::-webkit-calendar-picker-indicator": { cursor: "pointer" }
              }}
              inputProps={{
                min: startDate,
                max: today,
              }}
            />
            
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={dateRangeCancel} variant="outlined" sx={{
            textTransform: "none"
          }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApply}
            disabled={!!error}
            sx={{
              textTransform: "none"
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
